import { render, staticRenderFns } from "./data80.vue?vue&type=template&id=281c3dff&scoped=true&"
import script from "./data80.vue?vue&type=script&lang=js&"
export * from "./data80.vue?vue&type=script&lang=js&"
import style1 from "./data80.vue?vue&type=style&index=1&id=281c3dff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281c3dff",
  null
  
)

export default component.exports